import { AxiosRequestConfig } from "axios";
import axiosInstance from "./axiosInstance";

const baseURL = window.location.origin.endsWith('/')
  ? window.location.origin
  : `${window.location.origin}/`;

// 🔹 Token Extraction Helper
const getToken = (isCandidate: boolean): string | null => {
  if (isCandidate) {
    const sessionData = sessionStorage.getItem("candidate_session");
    if (!sessionData) return null;

    try {
      const session = JSON.parse(sessionData);
      return session?.candidate_access_token || null;
    } catch {
      return null;
    }
  }

  return localStorage.getItem("access_token");
};

// 🔹 Dynamic Token Fetching
const getAuthHeaders = (
  tenant: string,
  requireAuth = true,
  contentType = "application/json",
  isCandidate = false
) => {
  const token = getToken(isCandidate);

  if (requireAuth && !token) {
    window.location.href = `${baseURL}${tenant}/SignIn`;
    throw new Error("No token found, redirecting to SignIn");
  }

  const headers: Record<string, string> = {
    "Content-Type": contentType,
    "X-Tenant": tenant,
    "X-App": baseURL,
    "Require-Auth": requireAuth ? "true" : "false",
  };

  if (requireAuth && token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  return headers;
};

// 🔹 GET Request
export const getRequest = async (
  endpoint: string,
  params = {},
  tenant: any,
  requireAuth = true,
  isCandidate = false
) => {
  try {
    const response = await axiosInstance.get(endpoint, {
      params,
      headers: getAuthHeaders(tenant, requireAuth, "application/json", isCandidate),
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// 🔹 POST JSON Request
export const postJsonRequest = async (
  endpoint: string,
  data: any,
  tenant: any,
  requireAuth = true,
  responseType?: any,
  isCandidate = false
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: getAuthHeaders(tenant, requireAuth, "application/json", isCandidate),
    };

    if (responseType) {
      config.responseType = responseType;
    }

    const response = await axiosInstance.post(endpoint, data, config);
    return response;
  } catch (error) {
    throw error;
  }
};

// 🔹 POST Form Request
export const postFormRequest = async (
  endpoint: string,
  data: any,
  tenant: any,
  requireAuth = true,
  responseType?: any,
  isCandidate = false
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: getAuthHeaders(tenant, requireAuth, "multipart/form-data", isCandidate),
    };

    if (responseType) {
      config.responseType = responseType;
    }

    const response = await axiosInstance.post(endpoint, data, config);
    return response;
  } catch (error) {
    throw error;
  }
};
